<template>
  <div
    v-if="canSee"
    ref="tabItem"
    class="header__menu-item flex items-center"
  >
    <router-link
      v-if="to"
      :class="[
        {'header__menu-link--active': activeLink, 'header__menu-link--has-icon': icon },
        'header__menu-link flex items-center px-4'
      ]"
      :to="to"
      :target="target"
      :data-text="name"
      exact
    >
      <div
        v-if="icon"
        class="header__tab-icon mr-2"
      >
        <dynamic-icon :icon="icon" />
      </div>
      <span
        :class="{'header__menu-text--active': activeLink}"
        class="header__menu-text"
      >
        {{ name }}
      </span>

      <slot />
    </router-link>

    <a
      v-else
      :target="target"
      :href="href"
      class="nav-link flex items-center px-4"
    >
      <span
        v-if="icon"
        class="header__tab-icon mr-2"
      >
        <dynamic-icon :icon="icon" />
      </span>
      <span
        :class="{'header__menu-text--active': activeLink}"
        class="header__menu-text"
      >
        {{ name }}
      </span>
      <slot />
    </a>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { checkRole } from '@/constants';
import DynamicIcon from '@/components/DynamicIcon.vue';

export default {
  name:       'VNavMenuItem',
  components: {
    DynamicIcon,
  },
  props: {
    name:       { type: String, default: '' },
    icon:       { type: String, default: '' },
    href:       { type: [String, null], default: '#' },
    to:         { type: [String, Object, null], default: null },
    slug:       { type: String, default: null },
    index:      { type: [String, Number], default: null },
    target:     { type: String, default: '_self' },
    isDisabled: { type: Boolean, default: false },
    isSubmenu:  { type: Boolean, default: false },
  },
  data() {
    return {
      observerStyle: 0,
      opacity:       0,

    };
  },
  computed: {
    ...mapGetters({
      userInfo: 'userInfo',
    }),
    canSee() {
      return this.to ? checkRole(this.$router.match(this.to).meta.rule, this.userInfo.userRole) : true;
    },
    activeLink() {
      return !!((((this.to === this.$route.path) || (this.$route.meta.parent === this.slug)) && this.to));
    },
    width() {
      return this.canSee ? `${this.$refs.tabItem.offsetWidth}px` : 0;
    },
    left() {
      return this.canSee ? `${this.$refs.tabItem.offsetLeft - 1}px` : 0;
    },
  },
  watch: {
    activeLink(val) {
      if (val) this.sendParentStyle(val);
    },
  },
  mounted() {
    this.sendParentStyle();
  },
  methods: {
    sendParentStyle(isFormWatch = false) {
      if (!this.canSee || this.isSubmenu) return;

      if (isFormWatch || this.activeLink) {
        this.$nextTick(() => {
          const { offsetWidth, offsetLeft } = this.$refs.tabItem;
          this.$emit('getActiveLinkStyle', { width: `${offsetWidth}px`, left: `${offsetLeft}px` });
        });
      }
    },
  },
};

</script>

<style lang="scss">
@import "@/assets/scss/vuexy/components/horizontalNavMenuItem.scss";
</style>
